import { action, atom, withInit } from '@reatom/framework'

import { Network } from '@root/entities/network'
import { TradeSettings } from '@root/entities/trade-settings'
import {
  tradeSettingsAtom,
  openTradeSettingsDialogEvent,
} from '@root/features/trade/trade-settings'
import { environmentAtom } from '@root/shared'

export const reatomTransferSvmFee = () => {
  const svmFeeSettingsAtom = atom(
    TradeSettings.SVM_NULL_SETTINGS,
    'svmFeeSettingsAtom',
  ).pipe(
    withInit((ctx) => {
      const settings = ctx.get(tradeSettingsAtom)
      if (settings.network !== Network.Solana) {
        return TradeSettings.SVM_NULL_SETTINGS
      }
      return settings
    }),
  )

  const changeAction = action((ctx) => {
    openTradeSettingsDialogEvent(ctx, {})
  }, 'changeAction')

  const totalFeeAtom = atom((ctx) => {
    const settings = ctx.spy(svmFeeSettingsAtom)
    const { transferFeeSvm } = ctx.get(environmentAtom)
    const priorityFee = settings.jitoEnabled
      ? settings.jitoTip
      : settings.priorityFee

    return transferFeeSvm + priorityFee
  }, 'totalFeeAtom')

  return {
    svmFeeSettingsAtom,
    changeAction,
    totalFeeAtom,
  }
}
export type TransferSvmFeeReatom = ReturnType<typeof reatomTransferSvmFee>
